import classNames from "classnames";
import { ActionIcon } from "PFComponents/action_icon/action_icon";
import { Inline } from "PFComponents/containers";
import type { DragHandleProps } from "PFComponents/floating_expandable_bubble";
import { Icon } from "PFComponents/icon";
import { Ref } from "react";
import { useTranslation } from "react-i18next";

import css from "./propilot_panel_header.module.scss";

type ProPilotPanelHeaderProps = {
  titleId: string;
  dragHandleProps?: DragHandleProps;
  areHeaderControlsVisible?: boolean;
  minimizeRef?: Ref<HTMLButtonElement>;
  onClear: () => void;
  onMinimize: () => void;
  onTurnOff: () => void;
};

export const ProPilotPanelHeader = ({
  titleId,
  dragHandleProps,
  areHeaderControlsVisible = true,
  minimizeRef,
  onClear,
  onMinimize,
  onTurnOff
}: ProPilotPanelHeaderProps) => {
  const { t } = useTranslation("translation");

  return (
    <div className={classNames(css.header, { [css.headerControlsHidden]: !areHeaderControlsVisible })}>
      <Inline
        alignItems="center"
        gap="spacingSm"
        grow={1}
        ref={dragHandleProps?.ref}
        className={css.handle}
        {...(dragHandleProps?.attributes ?? {})}
        {...(dragHandleProps?.listeners ?? {})}
      >
        <Icon name="ai-agent" size="sm" color="paletteWhite0" />
        <span id={titleId} className={css.title}>
          {t("propilot.panel.title")}
        </span>
      </Inline>
      <Inline alignItems="center" gap="spacingSm" className={css.actions}>
        <ActionIcon
          name="remove-all"
          size="sm"
          color="paletteWhite0"
          title={t("propilot.panel.clear")}
          qaId="ProPilotPanel.clear"
          onClick={onClear}
          classes={{ root: css.actionIcon }}
        />
        <ActionIcon
          ref={minimizeRef}
          name="collapse"
          size="sm"
          color="paletteWhite0"
          title={t("propilot.panel.minimize")}
          qaId="ProPilotPanel.minimize"
          onClick={onMinimize}
          classes={{ root: css.actionIcon }}
        />
        <ActionIcon
          name="cross"
          size="sm"
          color="paletteWhite0"
          title={t("propilot.panel.close")}
          qaId="ProPilotPanel.close"
          onClick={onTurnOff}
          classes={{ root: css.actionIcon }}
        />
      </Inline>
    </div>
  );
};
